import React, { useEffect, useState } from 'react';
import './App.css';
import '../src/static/css/swal.css';
import {
  BrowserRouter, Route, Routes, Navigate
} from "react-router-dom";
import SecureLS from 'secure-ls';
import axios from 'axios';
import Login from './screens/Login';
import Register from './screens/Register';
import ResetPassword from './screens/ResetPassword';
import ManageUser from './screens/ManageUser';
import EditUser from './screens/EditUser';
import Header from './components/Header';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Sebi_Registration from './screens/Sebi_Registration';
import Rtareg from './screens/Rtareg';
import Landing from './screens/Landing';
import { UserTypeContext } from './MyContext';
import EmailForResetpassword from './screens/EmailForResetpassword';
import ProtectedRoutes from './utils/ProtectedRoutes';
import ErrorModule from './screens/ErrorModule';

function App() {

  const [isLoggedIn, setIsLoggedIn] = useState(sessionStorage.getItem("token"));
  const [userType, setUserType] = useState("PMS");

  return (
    <UserTypeContext.Provider value={{ userType, setUserType }}>
      <div className='App' >
        <Header />
        <BrowserRouter>
          <Routes>
            <Route element={<ProtectedRoutes />}>
              <Route path="/Register" element={<Register />} />
              <Route path="/Landing" element={<Landing />} />
              <Route path="/ManageUser" element={<ManageUser />} />
              <Route path="/EditUser" element={<EditUser />} />
              <Route path='*' element={<ErrorModule/>} />
            </Route>
            <Route path="/EmailForResetpassword/" element={<EmailForResetpassword />} />
            <Route path="/ResetPassword/*" element={<ResetPassword />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/" element={<Login />} />
            <Route path='*' element={<ErrorModule/>} />
          </Routes>
        </BrowserRouter>
        <Footer />
      </div>
    </UserTypeContext.Provider>
  );
}

export default App;
